var map = {
	"./airbnbLogo.png": 78,
	"./codeInLogo.webp": 163,
	"./contactMail.webp": 164,
	"./contactMailDark.svg": 165,
	"./dailyciousdabba.png": 166,
	"./dailyciousdabba.webp": 80,
	"./developerActivity.svg": 85,
	"./facebookLogo.png": 76,
	"./googleAssistant.svg": 167,
	"./googleAssistantLogo.webp": 168,
	"./hacktoberfest2020-new.svg": 81,
	"./hacktoberfest2020.webp": 169,
	"./harvardLogo.png": 170,
	"./iic-logo.png": 82,
	"./jsFramework.svg": 171,
	"./julogo.png": 75,
	"./manOnTable.svg": 84,
	"./nextuLogo.webp": 172,
	"./programmer.svg": 173,
	"./pwa.webp": 174,
	"./pwaLogo.webp": 175,
	"./quoraLogo.png": 77,
	"./saayaHealthLogo.webp": 176,
	"./skill.svg": 86,
	"./stanfordLogo.png": 177,
	"./talksCardBack.svg": 178,
	"./talksCardBackAlt.svg": 179,
	"./voltroph-new.webp": 79,
	"./voltroph.webp": 180
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 162;